import {
  AdminPartCheckRequest,
  AdminPartCheckResponse,
  AdminPartCreateRequest,
  AdminPartCreateResponse,
  AdminPartOptionAddRequest,
  AdminPartOptionsListResponse,
  AdminPartsListRequest,
  AdminPartsListResponse,
  AdminPartSubstituteAddRequest,
  AdminPartSubstitutesListResponse,
  AdminPartUpdateRequest,
  AdminPartUpdateResponse,
} from '@/venit/services/model/techpubs-cms';
import axios, { AxiosResponse } from 'axios';

export default class PartsManagementService {

  public listParts(request: AdminPartsListRequest): Promise<AxiosResponse<AdminPartsListResponse>> {
    return axios.post<AdminPartsListResponse>('/api/admin/parts/list', request);
  }

  public createPart(request: AdminPartCreateRequest): Promise<AxiosResponse<AdminPartCreateResponse>> {
    return axios.post<AdminPartCreateResponse>('/api/admin/parts/create', request);
  }

  public updatePart(request: AdminPartUpdateRequest): Promise<AxiosResponse<AdminPartUpdateResponse>> {
    return axios.post<AdminPartUpdateResponse>('/api/admin/parts/update', request);
  }

  public checkExists(request: AdminPartCheckRequest): Promise<AxiosResponse<AdminPartCheckResponse>> {
    return axios.post<AdminPartCheckResponse>('/api/admin/parts/check-exists', request);
  }

  // Options

  public listOptions(nameId: string): Promise<AxiosResponse<AdminPartOptionsListResponse>> {
    return axios.get<AdminPartOptionsListResponse>(`/api/admin/parts/${encodeURIComponent(nameId)}/options`);
  }

  public saveOption(nameId: string, request: AdminPartOptionAddRequest): Promise<AxiosResponse<AdminPartOptionsListResponse>> {
    return axios.post<AdminPartOptionsListResponse>(`/api/admin/parts/${encodeURIComponent(nameId)}/options`, request);
  }

  public deleteOption(nameId: string, optionCode: string): Promise<AxiosResponse<AdminPartOptionsListResponse>> {
    return axios.delete<AdminPartOptionsListResponse>(`/api/admin/parts/${encodeURIComponent(nameId)}/options/${encodeURIComponent(optionCode)}`);
  }

  // Substitutes

  public listSubstitutes(nameId: string): Promise<AxiosResponse<AdminPartSubstitutesListResponse>> {
    return axios.get<AdminPartSubstitutesListResponse>(`/api/admin/parts/${encodeURIComponent(nameId)}/substitutes`);
  }

  public saveSubstitute(nameId: string, request: AdminPartSubstituteAddRequest): Promise<AxiosResponse<AdminPartSubstitutesListResponse>> {
    return axios.post<AdminPartSubstitutesListResponse>(`/api/admin/parts/${encodeURIComponent(nameId)}/substitutes`, request);
  }

  public deleteSubstitute(nameId: string, substituteId: number): Promise<AxiosResponse<AdminPartSubstitutesListResponse>> {
    return axios.delete<AdminPartSubstitutesListResponse>(`/api/admin/parts/${encodeURIComponent(nameId)}/substitutes/${substituteId}`);
  }
}
